export type ContractManagerPermissions = {
	invite: boolean;
	toggle_access: boolean;
	logout: boolean;
};

export type ContractManagerPermissionsEntry = ContractManagerPermissions & {
	email: string;
};

export const FULL_PERMISSIONS: ContractManagerPermissions = {
	invite: true,
	toggle_access: true,
	logout: true,
};

export const PERMISSION_LABELS: { key: keyof ContractManagerPermissions; label: string }[] = [
	{ key: 'invite', label: 'Convidar Novos Usuários' },
	{ key: 'toggle_access', label: 'Ativar/Desativar Usuários' },
	{ key: 'logout', label: 'Deslogar Usuários' },
];

export function permissions_of(
	entries: ContractManagerPermissionsEntry[],
	email: string
): ContractManagerPermissions {
	const entry = entries.find((e) => e.email?.trim().toLowerCase() === email.trim().toLowerCase());

	if (!entry) {
		return FULL_PERMISSIONS;
	}

	return {
		invite: entry.invite !== false,
		toggle_access: entry.toggle_access !== false,
		logout: entry.logout !== false,
	};
}
